import { AnyType } from './any.js';
export class DateType extends AnyType {
    create() {
        return new Date();
    }
    convert(next, a, record, options) {
        if (next == null || next instanceof Date)
            return next;
        const date = new Date(next), timestamp = date.getTime();
        if (timestamp !== timestamp) {
            this._log('error', 'Type-R:InvalidDate', 'Date attribute assigned with invalid date', next, record, options.logger);
        }
        return date;
    }
    validate(model, value, name) {
        if (value != null) {
            const timestamp = value.getTime();
            if (timestamp !== timestamp)
                return name + ' is Invalid Date';
        }
    }
    toJSON(value) { return value && value.toISOString(); }
    isChanged(a, b) { return (a && a.getTime()) !== (b && b.getTime()); }
    doInit(value, record, options) {
        return this.transform(value === void 0 ? this.defaultValue() : value, void 0, record, options);
    }
    doUpdate(value, record, options, nested) {
        const { name } = this, { attributes } = record, prev = attributes[name];
        return this.isChanged(prev, attributes[name] = this.transform(value, prev, record, options));
    }
    clone(value) { return value && new Date(value.getTime()); }
    dispose() { }
}
function supportsDate(date) {
    return !isNaN((new Date(date)).getTime());
}
if (!supportsDate('2011-11-29T15:52:30.5') ||
    !supportsDate('2011-11-29T15:52:30.52') ||
    !supportsDate('2011-11-29T15:52:18.867') ||
    !supportsDate('2011-11-29T15:52:18.867Z') ||
    !supportsDate('2011-11-29T15:52:18.867-03:30')) {
    DateType.prototype.convert = function (value) {
        return value == null || value instanceof Date ? value : new Date(safeParseDate(value));
    };
}
const numericKeys = [1, 4, 5, 6, 7, 10, 11], isoDatePattern = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::(\d{2}))?)?)?$/;
function safeParseDate(date) {
    var timestamp, struct, minutesOffset = 0;
    if ((struct = isoDatePattern.exec(date))) {
        for (var i = 0, k; (k = numericKeys[i]); ++i) {
            struct[k] = +struct[k] || 0;
        }
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1;
        if (struct[8] !== 'Z' && struct[9] !== undefined) {
            minutesOffset = struct[10] * 60 + struct[11];
            if (struct[9] === '+') {
                minutesOffset = 0 - minutesOffset;
            }
        }
        timestamp =
            Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
    else {
        timestamp = Date.parse(date);
    }
    return timestamp;
}
//# sourceMappingURL=date.js.map